(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["shop-the-room-carousel"] && !Shopify.designMode) return;
  try {
    
(function () {
  "use strict";
  var root = document.querySelector("[data-str]");
  if (!root || !window.STR_DATA) return;
  var products = window.STR_DATA.products || {};
  var pins = root.querySelectorAll("[data-str-pin]");
  var hints = root.querySelectorAll("[data-str-hint]");
  var overlay = root.querySelector("[data-str-overlay]");
  var drawer = root.querySelector("[data-str-drawer]");
  var atcVariant = null, lastFocused = null;

  function money(v) { if (v == null || v === "") return ""; if (typeof v === "string") return v; return "$" + (v / 100).toFixed(2).replace(/\.00$/, ""); }
  function cdn(u, w) { if (!u) return u; if (/[?&]width=/.test(u)) return u; return u + (u.indexOf("?") === -1 ? "?" : "&") + "width=" + w; }
  function q(sel) { return drawer.querySelector(sel); }

  /* ---- Carousel ---- */
  var track = root.querySelector("[data-str-track]");
  var slides = root.querySelectorAll("[data-str-slide]");
  var dots = root.querySelectorAll("[data-str-dot]");
  var prevBtn = root.querySelector("[data-str-prev]");
  var nextBtn = root.querySelector("[data-str-next]");
  var index = 0, scrollTimer = null;

  function sync(i) {
    dots.forEach(function (d, j) { d.classList.toggle("is-active", j === i); });
    if (prevBtn) prevBtn.disabled = i <= 0;
    if (nextBtn) nextBtn.disabled = i >= slides.length - 1;
  }
  function go(i) {
    i = Math.max(0, Math.min(i, slides.length - 1));
    index = i;
    if (track) { if (track.scrollTo) { track.scrollTo({ left: i * track.clientWidth, behavior: "smooth" }); } else { track.scrollLeft = i * track.clientWidth; } }
    sync(i);
  }
  if (track) {
    track.addEventListener("scroll", function () {
      clearTimeout(scrollTimer);
      scrollTimer = setTimeout(function () {
        var i = Math.round(track.scrollLeft / track.clientWidth);
        if (i !== index) { index = i; sync(i); }
      }, 90);
    }, { passive: true });
  }
  if (prevBtn) prevBtn.addEventListener("click", function () { go(index - 1); });
  if (nextBtn) nextBtn.addEventListener("click", function () { go(index + 1); });
  dots.forEach(function (d, j) { d.addEventListener("click", function () { go(j); }); });
  sync(0);

  /* ---- Drawer ---- */
  function openDrawer(id) {
    var p = products[id]; if (!p || !drawer) return;
    lastFocused = document.activeElement;
    hints.forEach(function (h) { h.classList.add("is-hidden"); });
    pins.forEach(function (el) { el.classList.toggle("is-active", el.getAttribute("data-str-pin") === id); });
    paint(p);
    document.body.style.overflow = "hidden";
    overlay.classList.add("is-open");
    drawer.classList.add("is-open");
    drawer.setAttribute("aria-hidden", "false");
    var c = q("[data-str-close]"); if (c) c.focus();
  }

  function paint(p) {
    q("[data-str-d-img]").src = cdn(p.img, 800);
    q("[data-str-d-img]").alt = p.name;
    q("[data-str-d-img]").title = p.name;
    q("[data-str-d-name]").textContent = p.name || "";
    var vEl = q("[data-str-d-variant]");
    if (vEl) { var vt = p.variant || ""; if (!vt || vt === "Default Title") { vEl.textContent = ""; vEl.setAttribute("hidden", ""); } else { vEl.textContent = vt; vEl.removeAttribute("hidden"); } }
    q("[data-str-d-price]").innerHTML = money(p.price) + (p.was ? "<span class='was'>" + money(p.was) + "</span>" : "");
    q("[data-str-d-desc]").textContent = p.desc || "";
    q("[data-str-d-view]").href = p.url || "#";
    var leadEl = q("[data-str-d-lead]");
    function setLead(t) { if (leadEl) { leadEl.textContent = t || ""; if (t) { leadEl.removeAttribute("hidden"); } else { leadEl.setAttribute("hidden", ""); } } }
    setLead(p.lead);
    var wrap = q("[data-str-d-swatches]"); wrap.innerHTML = "";
    var list = p.swatches && p.swatches.length ? p.swatches : null;
    if (list && list.length > 1) {
      list.forEach(function (sw, i) {
        var b = document.createElement("button");
        b.type = "button"; b.className = "str-swatch";
        b.style.backgroundImage = "url('" + cdn(sw.src || sw.img, 80) + "')";
        b.setAttribute("aria-label", sw.label); b.title = sw.label;
        if ((p.variantId && sw.variantId === p.variantId) || (!p.variantId && i === 0)) b.classList.add("is-active");
        b.addEventListener("click", function () {
          wrap.querySelectorAll(".str-swatch").forEach(function (x) { x.classList.remove("is-active"); });
          b.classList.add("is-active");
          q("[data-str-d-img]").src = cdn(sw.img || sw.src || p.img, 800);
          if (vEl) { vEl.textContent = sw.label; vEl.removeAttribute("hidden"); }
          var was = sw.was != null ? sw.was : p.was;
          q("[data-str-d-price]").innerHTML = money(sw.price != null ? sw.price : p.price) + (was ? "<span class='was'>" + money(was) + "</span>" : "");
          atcVariant = sw.variantId || p.variantId;
          setAtc(sw.available !== false);
          setLead(sw.lead != null ? sw.lead : p.lead);
        });
        wrap.appendChild(b);
      });
    }
    atcVariant = p.variantId;
    setAtc(p.available !== false);
    setMsg("", "");
  }

  function setAtc(av) { var b = q("[data-str-atc]"); if (!b) return; b.disabled = !av; b.textContent = av ? "Add to Cart" : "Sold out"; }
  function setMsg(t, k) { var e = q("[data-str-msg]"); if (!e) return; e.textContent = t; e.className = "str-drawer__msg" + (k ? " is-" + k : ""); }

  function closeDrawer() {
    drawer.classList.remove("is-open");
    overlay.classList.remove("is-open");
    drawer.setAttribute("aria-hidden", "true");
    document.body.style.overflow = "";
    pins.forEach(function (el) { el.classList.remove("is-active"); });
    if (lastFocused && lastFocused.focus) lastFocused.focus();
  }

  function addToCart() {
    if (!atcVariant) { setMsg("Select an option", "err"); return; }
    var b = q("[data-str-atc]");
    if (window.STR_DATA.previewMode) { setMsg("Added to cart (preview)", "ok"); return; }
    b.disabled = true;
    var routes = (window.flcForge && window.flcForge.routes) || {};
    var addUrl = routes.cart_add_url || "/cart/add.js";
    var req = (window.FLC && FLC.fetchJSON)
      ? FLC.fetchJSON(addUrl, { method: "POST", body: JSON.stringify({ id: atcVariant, quantity: 1 }) })
      : fetch(addUrl, { method: "POST", headers: { "Content-Type": "application/json" }, body: JSON.stringify({ id: atcVariant, quantity: 1 }) }).then(function (r) { if (!r.ok) throw new Error("cart"); return r.json(); });
    req
      .then(function () {
        closeDrawer();
        if (window.FLC && FLC.dispatch) {
          FLC.dispatch("flc:cart:refresh");
          if (((window.flcForge && window.flcForge.cartType) || "drawer") === "drawer") FLC.dispatch("flc:cart:open");
          else if (routes.cart_url) window.location.href = routes.cart_url;
        } else {
          document.dispatchEvent(new CustomEvent("flc:cart:refresh", { bubbles: true }));
          document.dispatchEvent(new CustomEvent("flc:cart:open", { bubbles: true }));
        }
        if (window.liveRegion && window.liveRegion.announce) window.liveRegion.announce("Added to cart");
      })
      .catch(function () { setMsg("Could not add — please try again", "err"); })
      .finally(function () { b.disabled = false; });
  }

  pins.forEach(function (p) {
    var id = p.getAttribute("data-str-pin");
    p.addEventListener("click", function () { openDrawer(id); });
    p.addEventListener("keydown", function (e) { if (e.key === "Enter" || e.key === " ") { e.preventDefault(); openDrawer(id); } });
    var sx = 0, sy = 0;
    p.addEventListener("touchstart", function (e) { sx = e.touches[0].clientX; sy = e.touches[0].clientY; }, { passive: true });
    p.addEventListener("touchend", function (e) { var t = e.changedTouches[0]; if (Math.abs(t.clientX - sx) < 10 && Math.abs(t.clientY - sy) < 10) { e.preventDefault(); openDrawer(id); } });
  });
  if (drawer) {
    var c = drawer.querySelector("[data-str-close]"); if (c) c.addEventListener("click", closeDrawer);
    var a = drawer.querySelector("[data-str-atc]"); if (a) a.addEventListener("click", addToCart);
  }
  if (overlay) overlay.addEventListener("click", closeDrawer);

  // Mobile bottom sheet: grab handle closes; swipe the header down to dismiss.
  var grab = drawer && drawer.querySelector("[data-str-grab]");
  if (grab) grab.addEventListener("click", closeDrawer);
  var dragEl = drawer && drawer.querySelector("[data-str-drag]");
  if (drawer && dragEl) {
    var startY = null, delta = 0;
    function dstart(e) { if (window.innerWidth > 767) return; startY = e.touches[0].clientY; delta = 0; drawer.style.transition = "none"; }
    function dmove(e) { if (startY === null) return; delta = e.touches[0].clientY - startY; if (delta < 0) delta = 0; drawer.style.transform = "translateY(" + delta + "px)"; }
    function dend() { if (startY === null) return; drawer.style.transition = ""; drawer.style.transform = ""; if (delta > 90) closeDrawer(); startY = null; delta = 0; }
    [grab, dragEl].forEach(function (el) {
      if (!el) return;
      el.addEventListener("touchstart", dstart, { passive: true });
      el.addEventListener("touchmove", dmove, { passive: true });
      el.addEventListener("touchend", dend);
    });
  }

  document.addEventListener("keydown", function (e) { if (e.key === "Escape" && drawer && drawer.classList.contains("is-open")) closeDrawer(); });
  document.addEventListener("keydown", function (e) {
    if (e.key !== "Tab" || !drawer || !drawer.classList.contains("is-open")) return;
    var f = drawer.querySelectorAll('button, a[href], input, [tabindex]:not([tabindex="-1"])');
    f = Array.prototype.filter.call(f, function (el) { return el.offsetParent !== null && !el.disabled; });
    if (!f.length) return;
    var first = f[0], last = f[f.length - 1];
    if (e.shiftKey && document.activeElement === first) { e.preventDefault(); last.focus(); }
    else if (!e.shiftKey && document.activeElement === last) { e.preventDefault(); first.focus(); }
  });
})();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["shop-the-room"] && !Shopify.designMode) return;
  try {
    
(function () {
  "use strict";
  var root = document.querySelector("[data-str]");
  if (!root || !window.STR_DATA) return;
  var products = window.STR_DATA.products || {};
  var pins = root.querySelectorAll("[data-str-pin]");
  var hints = root.querySelectorAll("[data-str-hint]");
  var overlay = root.querySelector("[data-str-overlay]");
  var drawer = root.querySelector("[data-str-drawer]");
  var atcVariant = null, lastFocused = null;

  function money(v) { if (v == null || v === "") return ""; if (typeof v === "string") return v; return "$" + (v / 100).toFixed(2).replace(/\.00$/, ""); }
  function cdn(u, w) { if (!u) return u; if (/[?&]width=/.test(u)) return u; return u + (u.indexOf("?") === -1 ? "?" : "&") + "width=" + w; }
  function q(sel) { return drawer.querySelector(sel); }


  /* ---- Drawer ---- */
  function openDrawer(id) {
    var p = products[id]; if (!p || !drawer) return;
    lastFocused = document.activeElement;
    hints.forEach(function (h) { h.classList.add("is-hidden"); });
    pins.forEach(function (el) { el.classList.toggle("is-active", el.getAttribute("data-str-pin") === id); });
    paint(p);
    document.body.style.overflow = "hidden";
    overlay.classList.add("is-open");
    drawer.classList.add("is-open");
    drawer.setAttribute("aria-hidden", "false");
    var c = q("[data-str-close]"); if (c) c.focus();
  }

  function paint(p) {
    q("[data-str-d-img]").src = cdn(p.img, 800);
    q("[data-str-d-img]").alt = p.name;
    q("[data-str-d-img]").title = p.name;
    q("[data-str-d-name]").textContent = p.name || "";
    var vEl = q("[data-str-d-variant]");
    if (vEl) { var vt = p.variant || ""; if (!vt || vt === "Default Title") { vEl.textContent = ""; vEl.setAttribute("hidden", ""); } else { vEl.textContent = vt; vEl.removeAttribute("hidden"); } }
    q("[data-str-d-price]").innerHTML = money(p.price) + (p.was ? "<span class='was'>" + money(p.was) + "</span>" : "");
    q("[data-str-d-desc]").textContent = p.desc || "";
    q("[data-str-d-view]").href = p.url || "#";
    var leadEl = q("[data-str-d-lead]");
    function setLead(t) { if (leadEl) { leadEl.textContent = t || ""; if (t) { leadEl.removeAttribute("hidden"); } else { leadEl.setAttribute("hidden", ""); } } }
    setLead(p.lead);
    var wrap = q("[data-str-d-swatches]"); wrap.innerHTML = "";
    var list = p.swatches && p.swatches.length ? p.swatches : null;
    if (list && list.length > 1) {
      list.forEach(function (sw, i) {
        var b = document.createElement("button");
        b.type = "button"; b.className = "str-swatch";
        b.style.backgroundImage = "url('" + cdn(sw.src || sw.img, 80) + "')";
        b.setAttribute("aria-label", sw.label); b.title = sw.label;
        if ((p.variantId && sw.variantId === p.variantId) || (!p.variantId && i === 0)) b.classList.add("is-active");
        b.addEventListener("click", function () {
          wrap.querySelectorAll(".str-swatch").forEach(function (x) { x.classList.remove("is-active"); });
          b.classList.add("is-active");
          q("[data-str-d-img]").src = cdn(sw.img || sw.src || p.img, 800);
          if (vEl) { vEl.textContent = sw.label; vEl.removeAttribute("hidden"); }
          var was = sw.was != null ? sw.was : p.was;
          q("[data-str-d-price]").innerHTML = money(sw.price != null ? sw.price : p.price) + (was ? "<span class='was'>" + money(was) + "</span>" : "");
          atcVariant = sw.variantId || p.variantId;
          setAtc(sw.available !== false);
          setLead(sw.lead != null ? sw.lead : p.lead);
        });
        wrap.appendChild(b);
      });
    }
    atcVariant = p.variantId;
    setAtc(p.available !== false);
    setMsg("", "");
  }

  function setAtc(av) { var b = q("[data-str-atc]"); if (!b) return; b.disabled = !av; b.textContent = av ? "Add to Cart" : "Sold out"; }
  function setMsg(t, k) { var e = q("[data-str-msg]"); if (!e) return; e.textContent = t; e.className = "str-drawer__msg" + (k ? " is-" + k : ""); }

  function closeDrawer() {
    drawer.classList.remove("is-open");
    overlay.classList.remove("is-open");
    drawer.setAttribute("aria-hidden", "true");
    document.body.style.overflow = "";
    pins.forEach(function (el) { el.classList.remove("is-active"); });
    if (lastFocused && lastFocused.focus) lastFocused.focus();
  }

  function addToCart() {
    if (!atcVariant) { setMsg("Select an option", "err"); return; }
    var b = q("[data-str-atc]");
    if (window.STR_DATA.previewMode) { setMsg("Added to cart (preview)", "ok"); return; }
    b.disabled = true;
    var routes = (window.flcForge && window.flcForge.routes) || {};
    var addUrl = routes.cart_add_url || "/cart/add.js";
    var req = (window.FLC && FLC.fetchJSON)
      ? FLC.fetchJSON(addUrl, { method: "POST", body: JSON.stringify({ id: atcVariant, quantity: 1 }) })
      : fetch(addUrl, { method: "POST", headers: { "Content-Type": "application/json" }, body: JSON.stringify({ id: atcVariant, quantity: 1 }) }).then(function (r) { if (!r.ok) throw new Error("cart"); return r.json(); });
    req
      .then(function () {
        closeDrawer();
        if (window.FLC && FLC.dispatch) {
          FLC.dispatch("flc:cart:refresh");
          if (((window.flcForge && window.flcForge.cartType) || "drawer") === "drawer") FLC.dispatch("flc:cart:open");
          else if (routes.cart_url) window.location.href = routes.cart_url;
        } else {
          document.dispatchEvent(new CustomEvent("flc:cart:refresh", { bubbles: true }));
          document.dispatchEvent(new CustomEvent("flc:cart:open", { bubbles: true }));
        }
        if (window.liveRegion && window.liveRegion.announce) window.liveRegion.announce("Added to cart");
      })
      .catch(function () { setMsg("Could not add — please try again", "err"); })
      .finally(function () { b.disabled = false; });
  }

  pins.forEach(function (p) {
    var id = p.getAttribute("data-str-pin");
    p.addEventListener("click", function () { openDrawer(id); });
    p.addEventListener("keydown", function (e) { if (e.key === "Enter" || e.key === " ") { e.preventDefault(); openDrawer(id); } });
    var sx = 0, sy = 0;
    p.addEventListener("touchstart", function (e) { sx = e.touches[0].clientX; sy = e.touches[0].clientY; }, { passive: true });
    p.addEventListener("touchend", function (e) { var t = e.changedTouches[0]; if (Math.abs(t.clientX - sx) < 10 && Math.abs(t.clientY - sy) < 10) { e.preventDefault(); openDrawer(id); } });
  });
  if (drawer) {
    var c = drawer.querySelector("[data-str-close]"); if (c) c.addEventListener("click", closeDrawer);
    var a = drawer.querySelector("[data-str-atc]"); if (a) a.addEventListener("click", addToCart);
  }
  if (overlay) overlay.addEventListener("click", closeDrawer);

  // Mobile bottom sheet: grab handle closes; swipe the header down to dismiss.
  var grab = drawer && drawer.querySelector("[data-str-grab]");
  if (grab) grab.addEventListener("click", closeDrawer);
  var dragEl = drawer && drawer.querySelector("[data-str-drag]");
  if (drawer && dragEl) {
    var startY = null, delta = 0;
    function dstart(e) { if (window.innerWidth > 767) return; startY = e.touches[0].clientY; delta = 0; drawer.style.transition = "none"; }
    function dmove(e) { if (startY === null) return; delta = e.touches[0].clientY - startY; if (delta < 0) delta = 0; drawer.style.transform = "translateY(" + delta + "px)"; }
    function dend() { if (startY === null) return; drawer.style.transition = ""; drawer.style.transform = ""; if (delta > 90) closeDrawer(); startY = null; delta = 0; }
    [grab, dragEl].forEach(function (el) {
      if (!el) return;
      el.addEventListener("touchstart", dstart, { passive: true });
      el.addEventListener("touchmove", dmove, { passive: true });
      el.addEventListener("touchend", dend);
    });
  }

  document.addEventListener("keydown", function (e) { if (e.key === "Escape" && drawer && drawer.classList.contains("is-open")) closeDrawer(); });
  document.addEventListener("keydown", function (e) {
    if (e.key !== "Tab" || !drawer || !drawer.classList.contains("is-open")) return;
    var f = drawer.querySelectorAll('button, a[href], input, [tabindex]:not([tabindex="-1"])');
    f = Array.prototype.filter.call(f, function (el) { return el.offsetParent !== null && !el.disabled; });
    if (!f.length) return;
    var first = f[0], last = f[f.length - 1];
    if (e.shiftKey && document.activeElement === first) { e.preventDefault(); last.focus(); }
    else if (!e.shiftKey && document.activeElement === last) { e.preventDefault(); first.focus(); }
  });
})();

  } catch(e) { console.error(e); }
})();
})();
